import { Api } from "../axios";
import { CryptoUtils } from "../crypto";
const headers = {
    "Content-Type": "application/json;charset=utf-8",
};
const instance = new Api(process.env.VUE_APP_SERVER_HOST, headers);
/**
 * トークンリフレッシュ
 * @param {string} refreshToken リフレッシュトークン
 */
export const refreshToken = async function (refreshToken) {
    const params = {
        refreshToken: CryptoUtils.encryptoAes(refreshToken),
        commonKey: CryptoUtils.commonKeyEncryptoRsa(),
    };
    const response = await instance.post("/token-refresh", params);
    return response?.body;
};
/**
 * ログイン
 * @param {Function} callback コールバック関数
 * @param {string} crmUserId CRMユーザID
 * @param {string} password パスワード
 * @param {string} isDeviceChanged 端末変更確認フラグ
 */
export const login = async function (callback, crmUserId, password, isDeviceChanged, clientId) {
    const params = {
        crmUserId: crmUserId,
        password: password,
        isDeviceChanged: isDeviceChanged,
        clientId: clientId,
        commonKey: CryptoUtils.commonKeyEncryptoRsa(),
    };
    const response = await instance.post("/administrators/login", params);
    callback(response.body);
};
/**
 * 二段階認証送信
 * @param {Function} callback コールバック関数
 * @param {string} loginId ログインID
 * @param {string} oldPassword 現パスワード
 * @param {string} newPassword 新パスワード
 * @param {string} newPasswordConfirm 新パスワード（確認用）
 */
export const twoFactAuthentication = async function (callback, authCode, session, userType, crmUserId, clientId) {
    const params = {
        authCode: authCode,
        session: session,
        userType: userType,
        crmUserId: crmUserId,
        clientId: clientId,
    };
    const response = await instance.post("/two-fact-authentication", params);
    callback(response.body);
};
/**
 * パスワード更新
 * @param {Function} callback コールバック関数
 * @param {string} loginId ログインID
 * @param {string} oldPassword 現パスワード
 * @param {string} newPassword 新パスワード
 * @param {string} newPasswordConfirm 新パスワード（確認用）
 */
export const updatePassword = async function (callback, oldPassword, newPassword, newPasswordConfirm) {
    const params = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        newPasswordConfirm: newPasswordConfirm,
        accessToken: CryptoUtils.encryptoAes(localStorage.getItem("aToken")),
        commonKey: CryptoUtils.commonKeyEncryptoRsa(),
    };
    const response = await instance.post("/password-change", params);
    callback(response.body);
};
/**
 * パスワードリセット
 * @param {Function} callback コールバック関数
 * @param {string} phoneNum 電話番号
 */
export const resetPassword = async function (callback, phoneNum) {
    const params = {
        phoneNum: phoneNum,
        commonKey: CryptoUtils.commonKeyEncryptoRsa(),
        isAdmin: true,
    };
    const response = await instance.post("/password-reset", params);
    callback(response.body);
};
/**
 * 管理ユーザ検索
 * @param {?string} crmUserId CRMユーザID
 * @param {?string} storeId 店舗ID
 */
export const searchAdministrators = async function (crmUserId = null, storeId = null) {
    const params = {
        crmUserId: crmUserId,
        storeId: storeId,
    };
    const response = await instance.get("/administrators", params);
    return response?.body;
};
/**
 * 管理ユーザ削除
 * @param {string} crmUserId CRMユーザID
 */
export const deleteAdministrator = async function (crmUserId) {
    const params = {};
    const response = await instance.delete("/administrators/" + crmUserId, params);
    return response?.body;
};
/**
 * 管理ユーザ取得
 * @param {Function} callback コールバック関数
 * @param {string} crmUserId CRMユーザID
 */
export const getAdministrator = async function (callback, crmUserId) {
    const params = {
        crmUserId: crmUserId,
    };
    const response = await instance.get("/administrators/" + crmUserId, params);
    callback(response.body);
};
/**
 * 管理ユーザ更新
 * @param {Function} callback コールバック関数
 * @param {string} crmUserId CRMユーザID
 * @param {string} userName 管理ユーザ名
 * @param {string} storeId 店舗ID
 * @param {string} phoneNum 電話番号
 * @param {string} authType ユーザ区分
 */
export const updateAdministrator = async function (callback, crmUserId, userName, storeId, phoneNum, authType) {
    const params = {
        crmUserId: crmUserId,
        userName: userName,
        storeId: storeId,
        phoneNum: phoneNum,
        authType: authType,
        commonKey: CryptoUtils.commonKeyEncryptoRsa(),
    };
    const response = await instance.put("/administrators/" + crmUserId, params);
    callback(response.body);
};
/**
 * 管理ユーザ登録
 * @param {Function} callback コールバック関数
 * @param {string} crmUserId CRMユーザID
 * @param {string} userName 管理ユーザ名
 * @param {string} storeId 店舗ID
 * @param {string} phoneNum 電話番号
 * @param {?string} authType ユーザ区分
 */
export const registAdministrator = async function (callback, crmUserId, userName, storeId, phoneNum, authType) {
    const params = {
        crmUserId: crmUserId,
        userName: userName,
        storeId: storeId,
        phoneNum: phoneNum,
        authType: authType,
        commonKey: CryptoUtils.commonKeyEncryptoRsa(),
    };
    const response = await instance.post("/administrators", params);
    callback(response.body);
};
/**
 *ポイント一括付与履歴検索
 *@param {string} point_bulk_grant_history_id
 *@param {timestamp} operation_date_from
 *@param {timestamp} operation_date_to
 *@param {int} effective_period_date_from
 *@param {int} effective_period_date_to
 *@param {string} brand_id
 *@param {string} store_id
 *@param {string} publisher
 *@param {string} point_name
 *@param {int} points_min
 *@param {int} points_max
 */
export const searchPointBulkGrantHistory = async function (point_bulk_grant_history_id, operation_date_from, operation_date_to, effective_period_date_from, effective_period_date_to, brand_id, store_id, publisher, point_name, points_min, points_max) {
    const params = {
        point_bulk_grant_history_id: point_bulk_grant_history_id,
        operation_date_from: operation_date_from,
        operation_date_to: operation_date_to,
        effective_period_date_from: effective_period_date_from,
        effective_period_date_to: effective_period_date_to,
        brand_id: brand_id,
        store_id: store_id,
        publisher: publisher,
        point_name: point_name,
        points_min: points_min,
        points_max: points_max,
    };
    const response = await instance.get("/point/searchBulkGrantHistory", params);
    return response?.body;
};
/**
 * ポイント履歴検索API
 * @param {string} point_bulk_grant_history_id // 一括付与履歴ID
 * @param {string} point_type // ポイント種別
 * @param {int} history_type // 付与/利用
 * @param {string} note // 備考
 * @param {string} crm_customer_id // 顧客ID
 * @param {date} traded_at_from // 取引日From
 * @param {date} traded_at_to // 取引日To
 * @param {date} history_date_from // 付与/利用日From
 * @param {date} history_date_to // 付与/利用日To
 * @param {int} points_min // 付与/利用ポイントmin
 * @param {int} points_max // 付与/利用ポイントmax
 * @param {string} brand // ブランド
 * @param {string} store // 店舗
 * @param {date} expiration_date_from // 有効期限From
 * @param {date} expiration_date_to // 有効期限To
 * @param {number} target_trading_amount_from // 対象取引金額From
 * @param {number} target_trading_amount_to // 対象取引金額To
 */
export const searchPointHistory = async function (point_bulk_grant_history_id, point_type, history_type, note, crm_customer_id, traded_at_from, traded_at_to, history_date_from, history_date_to, points_min, points_max, brandStore, bill_no, expiration_date_from, expiration_date_to, target_trading_amount_from, target_trading_amount_to) {
    const param = {
        point_bulk_grant_history_id: point_bulk_grant_history_id,
        point_type: point_type,
        history_type: history_type,
        note: note,
        crm_customer_id: crm_customer_id,
        traded_at_from: traded_at_from,
        traded_at_to: traded_at_to,
        history_date_from: history_date_from,
        history_date_to: history_date_to,
        points_min: points_min,
        points_max: points_max,
        brandStore: brandStore,
        bill_no: bill_no,
        expiration_date_from: expiration_date_from,
        expiration_date_to: expiration_date_to,
        target_trading_amount_from: target_trading_amount_from,
        target_trading_amount_to: target_trading_amount_to,
    };
    const response = await instance.get("/point/searchHistory", param);
    return response?.body;
};
/**
 * クーポン生成API
 * @param brand_id
 * @param coupon_name
 * @param target_product_id
 * @param detailed_description
 * @param discount
 * @param discount_unit
 * @param term_of_use
 * @param expiration_date
 * @param available_times
 * @param publisher
 * @returns
 */
export const generateCoupon = async function (brand_id, coupon_name, target_product_id, detailed_description, discount, discount_unit, term_of_use, expiration_date, available_times, publisher) {
    const param = {
        brand_id: brand_id,
        coupon_name: coupon_name,
        target_product_id: target_product_id,
        detailed_description: detailed_description,
        discount: discount,
        discount_unit: discount_unit,
        term_of_use: term_of_use,
        expiration_date: expiration_date,
        available_times: available_times,
        publisher: publisher,
    };
    const response = await instance.post("/coupon/generate", param);
    return response?.body;
};
/**
 * クーポン詳細情報取得API
 * @param {string} coupon_code
 */
export const getCouponDetail = async function (coupon_code) {
    const param = {
        coupon_code: coupon_code,
    };
    const response = await instance.get("/coupon/getDetail", param);
    return response?.body;
};
/**
 * CSVインポートAPI
 * @param {FormData} csvFile
 * **/
export const importCsv = async function (csvFile) {
    const formData = new FormData();
    formData.append("csv", csvFile);
    const response = await instance.post("/user/importCsv", formData);
    return response?.body;
};
/**
 * ユーザ検索API
 * @param {string[]} crm_customer_ids
 * @param {string} mobile_phone_number
 * @param {string} name
 * @param {string} last_use_brand
 * @param {string} last_use_store
 * @param {date} last_use_at_from
 * @param {date} last_use_at_to
 */
export const searchUser = async function (crm_customer_ids, mobile_phone_number, name, last_use_brand, last_use_store, last_use_at_from, last_use_at_to) {
    const param = {
        crm_customer_ids: crm_customer_ids,
        mobile_phone_number: mobile_phone_number,
        name: name,
        last_use_brand: last_use_brand,
        last_use_store: last_use_store,
        last_use_at_from: last_use_at_from,
        last_use_at_to: last_use_at_to,
    };
    const response = await instance.post("/user/search", param);
    return response?.body;
};
/**
 * ブランドマスタ取得API
 * @param point_type_id
 * @returns
 */
export const getBrandsMaster = async function (point_type_id) {
    const param = {
        point_type_id: point_type_id,
    };
    const response = await instance.get("/master/get/brandsMaster", param);
    return response?.body;
};
/**
 * 支店マスタ取得API
 * @param brand_id
 * @returns
 */
export const getStoresMaster = async function (brand_id) {
    const param = {
        brand_id: brand_id,
    };
    const response = await instance.get("/master/get/storesMaster", param);
    return response?.body;
};
/**
 * クーポン対象商品マスタ取得API
 * @returns
 */
export const getCouponTargetProductsMaster = async function () {
    const param = {};
    const response = await instance.get("/master/get/couponTargetProducts", param);
    return response?.body;
};
/**
 * ポイント種別マスタ取得API
 * @returns
 */
export const getPointTypesMaster = async function () {
    const param = {};
    const response = await instance.get("/master/get/pointTypes", param);
    return response?.body;
};
export const usePoint = async (params) => {
    const response = await instance.post("/point/use", params);
    return response?.body;
};
export const bulkGrantPoint = async function (crm_customer_id_list, point_bulk_grant_info) {
    const param = {
        crm_customer_id_list: crm_customer_id_list,
        point_bulk_grant_info: point_bulk_grant_info,
    };
    const response = await instance.post("/point/bulkGrant", param);
    return response?.body;
};
/**
 * ポイント交換倍率検索API
 * @param filters 検索条件オブジェクト
 */
export const searchPointExchangeMagnifications = async function (filters) {
    // filtersをそのままGETパラメータとして送信
    const response = await instance.get("/master/search/pointExchangeMagnifications", filters);
    return response?.body;
};
/**
 * ポイント交換倍率登録API
 * @param registration 登録データオブジェクト
 */
export const createPointExchangeMagnification = async function (registration) {
    // POSTリクエストでボディに登録データを送信
    const response = await instance.post("/master/create/pointExchangeMagnifications", registration);
    return response?.body;
};
/**
 * ポイント交換倍率更新API
 * @param updateData 更新データオブジェクト
 */
export const updatePointExchangeMagnification = async function (updateData) {
    // postリクエストでボディに更新データを送信
    const response = await instance.post("/master/update/pointExchangeMagnifications", updateData);
    return response?.body;
};
/**
 * ポイント交換倍率削除API
 * @param point_exchange_magnification_id 削除対象のポイント交換倍率ID
 */
export const deletePointExchangeMagnification = async function (point_exchange_magnification_id) {
    // DELETEリクエストでIDを送信
    const response = await instance.post("/master/delete/pointExchangeMagnifications", { point_exchange_magnification_id });
    return response?.body;
};
/**
 * クーポン履歴検索API
 * @param coupon_bulk_operation_history_id
 * @param history_type
 * @param crm_customer_id
 * @param discount_min
 * @param discount_max
 * @param discount_unit
 * @param coupon_code
 * @param history_date_from
 * @param history_date_to
 * @param grant_brand
 * @param grant_store
 * @param use_brand
 * @param use_store
 * @param expiration_date_from
 * @param expiration_date_to
 * @param billing_amount_min
 * @param billing_amount_max
 * @param discount_amount_min
 * @param discount_amount_max
 * @param payment_amount_min
 * @param payment_amount_max
 * @returns
 */
export const searchCouponHistory = async function (coupon_bulk_operation_history_id, history_type, crm_customer_id, discount_min, discount_max, discount_unit, coupon_code, history_date_from, history_date_to, grant_brandStore, use_brandStore, expiration_date_from, expiration_date_to, billing_amount_min, billing_amount_max, discount_amount_min, discount_amount_max, payment_amount_min, payment_amount_max) {
    const param = {
        coupon_bulk_operation_history_id: coupon_bulk_operation_history_id,
        history_type: history_type,
        crm_customer_id: crm_customer_id,
        discount_min: discount_min,
        discount_max: discount_max,
        discount_unit: discount_unit,
        coupon_code: coupon_code,
        history_date_from: history_date_from,
        history_date_to: history_date_to,
        grant_brandStore: grant_brandStore,
        use_brandStore: use_brandStore,
        expiration_date_from: expiration_date_from,
        expiration_date_to: expiration_date_to,
        billing_amount_min: billing_amount_min,
        billing_amount_max: billing_amount_max,
        discount_amount_min: discount_amount_min,
        discount_amount_max: discount_amount_max,
        payment_amount_min: payment_amount_min,
        payment_amount_max: payment_amount_max,
    };
    const response = await instance.get("/coupon/searchHistory", param);
    return response?.body;
};
/**
 * クーポン削除API
 * @param coupon_code
 * @param operator
 * @returns
 */
export const deleteCoupon = async function (coupon_code, operator) {
    const param = {
        coupon_code: coupon_code,
        operator: operator,
    };
    const response = await instance.delete("/coupon/delete", param);
    return response?.body;
};
/**
 * クーポン検索API
 * @param coupon_code
 * @param brand_id
 * @param coupon_name
 * @param target_product_id
 * @param expiration_date_from
 * @param expiration_date_to
 * @param discount_min
 * @param discount_max
 * @param discount_unit
 * @param term_of_use
 * @param publisher
 * @returns
 */
export const searchCoupon = async function (coupon_code, brand_id, coupon_name, target_product_id, expiration_date_from, expiration_date_to, discount_min, discount_max, discount_unit, term_of_use, publisher) {
    const param = {
        coupon_code: coupon_code,
        brand_id: brand_id,
        coupon_name: coupon_name,
        target_product_id: target_product_id,
        expiration_date_from: expiration_date_from,
        expiration_date_to: expiration_date_to,
        discount_min: discount_min,
        discount_max: discount_max,
        discount_unit: discount_unit,
        term_of_use: term_of_use,
        publisher: publisher,
    };
    const response = await instance.get("/coupon/search", param);
    return response?.body;
};
/**
 * クーポン付与API
 * @param crm_customer_id_list
 * @param crm_customer_id
 * @param coupon_code
 * @param brand_id
 * @param store_id
 * @param granted_by
 * @returns
 */
export const grantCoupon = async function (crm_customer_id_list, coupon_code, brand_id, store_id, granted_by) {
    const param = {
        crm_customer_id_list: crm_customer_id_list,
        coupon_code: coupon_code,
        brand_id: brand_id,
        store_id: store_id,
        granted_by: granted_by,
    };
    const response = await instance.post("/coupon/grant", param);
    return response?.body;
};
/**
 * クーポン一括操作履歴検索API
 * @param coupon_bulk_operation_history_id
 * @param coupon_code
 * @param grant_date_from
 * @param grant_date_to
 * @param coupon_name
 * @param target_product_id
 * @param brand_id
 * @param store_id
 * @param operator
 * @param grant_number_min
 * @param grant_number_max
 * @param is_deleted
 * @returns
 */
export const searchCouponBulkOperationHistory = async function (coupon_bulk_operation_history_id, coupon_code, operation_type, grant_date_from, grant_date_to, coupon_name, target_product_id, brand_id, store_id, operator, grant_number_min, grant_number_max, is_deleted) {
    const param = {
        coupon_bulk_operation_history_id: coupon_bulk_operation_history_id,
        coupon_code: coupon_code,
        operation_type: operation_type,
        grant_date_from: grant_date_from,
        grant_date_to: grant_date_to,
        coupon_name: coupon_name,
        target_product_id: target_product_id,
        brand_id: brand_id,
        store_id: store_id,
        operator: operator,
        grant_number_min: grant_number_min,
        grant_number_max: grant_number_max,
        is_deleted: is_deleted,
    };
    const response = await instance.get("/coupon/searchBulkOperationHistory", param);
    return response?.body;
};
/**
 * クーポン削除結果取得API
 * @param coupon_code
 * @returns
 */
export const getCouponDeletingResult = async function (coupon_code) {
    const param = { coupon_code: coupon_code };
    const response = await instance.get("/coupon/getDeletingResult", param);
    return response?.body;
};
/**
 * ポイント対象外商品コード検索API
 * @param filters 検索条件オブジェクト
 */
export const searchPointExcludedProductCode = async function (filters) {
    // filtersをそのままGETパラメータとして送信
    const response = await instance.get("/master/search/nonTargetPointGrants", filters);
    return response?.body;
};
/**
 * ポイント対象外商品コード登録API
 * @param registration 登録データオブジェクト
 */
export const registerPointExcludedProductCode = async function (registration) {
    // POSTリクエストでボディに登録データを送信
    const response = await instance.post("/master/register/nonTargetPointGrants", registration);
    return response?.body;
};
/**
 * ポイント対象外商品コード更新API
 * @param updateData 更新データオブジェクト
 */
export const updatePointExcludedProductCode = async function (updateData) {
    // postリクエストでボディに更新データを送信
    const response = await instance.post("/master/update/nonTargetPointGrants", updateData);
    return response?.body;
};
/**
 * ポイント対象外商品コード削除API
 * @param point_exchange_magnification_id 削除対象のポイント交換倍率ID
 */
export const deletePointExcludedProductCode = async function (non_target_point_grant_id) {
    // DELETEリクエストでIDを送信
    const response = await instance.post("/master/delete/nonTargetPointGrants", {
        non_target_point_grant_id,
    });
    return response?.body;
};
